exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/library/modules/_object-gops.js
// module id = ../../../../core-js/library/modules/_object-gops.js
// module chunks = 3